/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';
import Attachmentutils from '../../attachment/index';
import ContextProcessor from '../../context/context-processor';
import type { NodeProps } from '../../contextree/types';

AnnotationsHandler.registerHandler(
  '@ATTACHMENT',
  (propertyRef: string, c11nEnv: C11nEnv, contextTreeNodeProps?: NodeProps) => {
    let resolvedData;
    if (c11nEnv) {
      resolvedData = c11nEnv.getValue(propertyRef);
    } else {
      resolvedData = ContextProcessor.getLitePropertyValue(contextTreeNodeProps);
    }

    return Attachmentutils.prepareAttachmentData(resolvedData);
  }
);
